/**
 * AOTD HTTP paths relative to `API_BASE_URL` (e.g. `/api`).
 *
 * `API_BASE_URL` (from `config/env`) already terminates in `/api`, so paths
 * declared here start at `/art-of-the-day/…`. The RTK `baseApi` query consumes
 * these directly; non-RTK callers (e.g. raw fetch for blob URLs) can prefix
 * with `API_BASE_URL`.
 */
export const aotdPaths = {
  today: "/art-of-the-day/today",
  status: "/art-of-the-day/status",
  info: "/art-of-the-day/info",
  todayImage: "/art-of-the-day/today-image",
  raceState: "/art-of-the-day/race-state",
  quote: "/art-of-the-day/quote",
  suggestQuote: "/art-of-the-day/suggest-quote",
  waybackTrigger: "/art-of-the-day/wayback/trigger",
  setNextEmojis: "/art-of-the-day/set-next-aotd-emojis",
  usedEmojis: "/art-of-the-day/used-emojis",
  emojiPenalty: "/art-of-the-day/emoji-penalty",
  comments: "/art-of-the-day/comments",
  audit: "/art-of-the-day/audit",
  /** The caller's own AOTD numbers (authed). Personal stats only. */
  myStats: "/art-of-the-day/me/stats",
} as const;
